var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSweden = function SvgSweden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Sweden_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-53.4 0h682.6v512H-53.4z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Sweden_svg__a)",
    transform: "translate(50)scale(.9375)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006aa7",
    d: "M-121.1.3h256v204.8h-256zm0 306.9h256V512h-256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecc00",
    d: "M-121.1 205h256v102.4h-256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecc00",
    d: "M133.8 0h102.4v512H133.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecc00",
    d: "M233 205h460.8v102.4H233z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006aa7",
    d: "M236.2 307.2H697V512H236.2zm0-306.9H697v204.8H236.2z"
  })))));
};
export default SvgSweden;